const ksefSearchParams = ["nr", "number", "ksef", "id", "identifier", "numer", "referenceNumber"];

const ksefQrHost = "qr.ksef.mf.gov.pl";
const ksefInvoicePathPrefix = "/invoice/";
const ksefClientAppInvoicePath = "/client-app/invoice/";

export function isKsefVerificationLink(raw: string): boolean {
  const trimmed = raw.trim();
  if (!trimmed) return false;
  try {
    const url = new URL(trimmed);
    return (
      url.hostname === ksefQrHost &&
      url.protocol === "https:" &&
      (url.pathname.startsWith(ksefClientAppInvoicePath) || url.pathname.startsWith(ksefInvoicePathPrefix))
    );
  } catch {
    return false;
  }
}

function ddMmYyyyToYyyyMmDd(ddMmYyyy: string): string | null {
  const m = ddMmYyyy.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!m) return null;
  return `${m[3]}${m[2]}${m[1]}`;
}

export function parseKsefQrContent(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return trimmed;

  try {
    const url = new URL(trimmed);
    if (url.hostname === ksefQrHost && url.pathname.startsWith(ksefClientAppInvoicePath)) {
      const parts = url.pathname.slice(ksefClientAppInvoicePath.length).split("/").filter(Boolean);
      const nip = parts[0];
      const dateDdMmYyyy = parts[1];
      if (nip && dateDdMmYyyy) {
        const yyyymmdd = ddMmYyyyToYyyyMmDd(dateDdMmYyyy);
        if (yyyymmdd) return `${nip}-${yyyymmdd}`;
        return `${nip} ${dateDdMmYyyy}`;
      }
      if (nip) return nip;
    }
    if (url.hostname === ksefQrHost && url.pathname.startsWith(ksefInvoicePathPrefix)) {
      const parts = url.pathname.slice(ksefInvoicePathPrefix.length).split("/").filter(Boolean);
      const nip = parts[0];
      const dateDdMmYyyy = parts[1];
      if (nip && dateDdMmYyyy) {
        const yyyymmdd = ddMmYyyyToYyyyMmDd(dateDdMmYyyy);
        if (yyyymmdd) return `${nip}-${yyyymmdd}`;
        return `${nip} ${dateDdMmYyyy}`;
      }
      if (nip) return nip;
    }
    if (url.hostname === ksefQrHost) {
      for (const param of ksefSearchParams) {
        const value = url.searchParams.get(param);
        if (value && value.trim()) return value.trim();
      }
    }
  } catch {
    return trimmed;
  }
  return "";
}
